import { api } from './client'

export const rciApi = {
  compute: (payload, token) => api.post('/rci/compute', payload, token),
  snapshot: (userId, token) => api.get(`/snapshot/${userId}`, token),
  history: (userId, limit = 30, token, before = null) => {
    const params = new URLSearchParams({ limit: String(limit) });
    if (before) params.set('before', before);
    return api.get(`/history/${userId}?${params.toString()}`, token);
  },
  chat: (payload, token) => api.post('/chat', payload, token),
  divergenceScan: (userId, date, token) => api.post('/divergence/scan', { user_id: userId, date }, token),
}
